module.exports = __webpack_public_path__ + "img/lock.f6f8b1eb.svg";